import {
  getCities,
  getPaginatedCities
} from "./chunk-FM76CYXU.mjs";
import {
  __spreadProps,
  __spreadValues
} from "./chunk-RGHW4PYM.mjs";

// src/hooks/wbk/city/cities.ts
import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
var useGetCities = (props, options) => {
  return useQuery(__spreadValues({
    queryKey: ["cities", props],
    queryFn: () => getCities(props)
  }, options));
};
var useGetPaginatedCities = (props) => {
  return useInfiniteQuery({
    queryKey: ["getPaginatedCities", props],
    queryFn: ({ pageParam = 1 }) => getPaginatedCities(__spreadProps(__spreadValues({}, props), {
      page: String(pageParam),
      per_page: props.per_page || 20
    })),
    getNextPageParam: (lastPage) => {
      const { current_page, last_page } = lastPage.meta;
      return current_page < last_page ? current_page + 1 : void 0;
    },
    initialPageParam: 1,
    select: (data) => data.pages.flatMap((page) => page.data)
  });
};

export {
  useGetCities,
  useGetPaginatedCities
};
//# sourceMappingURL=chunk-JH4FWPTD.mjs.map